import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';

/**
 * D-5 do dono (31/08/2026), literal: "vai buscar cliente, fornecedor,
 * colaboradores (estagiarios e funcionarios) e ponto, restante é só itens de
 * menu". Esta união É o escopo. Acrescentar um membro aqui é mudar a decisão
 * do dono, não estender um enum.
 */
export type TipoDeBusca = 'cliente' | 'fornecedor' | 'funcionario' | 'estagiario' | 'menu';

/** Uma linha da paleta. `rota` é o destino do Enter/clique. */
export interface ResultadoDeBusca {
  readonly tipo: TipoDeBusca;
  readonly id: string;
  readonly titulo: string;
  /** Segunda linha: documento, cargo ou o caminho do menu. Pode faltar. */
  readonly subtitulo: string | null;
  readonly rota: string;
}

export interface GrupoDeResultado {
  readonly tipo: TipoDeBusca;
  readonly rotulo: string;
  readonly icone: string;
  readonly itens: readonly ResultadoDeBusca[];
}

/**
 * A tabela que amarra tipo → permissão → listagem → ícone.
 *
 * As permissões são as MESMAS que `core/_config/menu/tenant/administrative.section.ts`
 * já declara em cada item e que `administrative-routing.module.ts` já exige
 * na rota. Isso é deliberado: uma busca mais permissiva que a rota mostraria
 * registro de tela que o usuário não abre; uma mais restrita esconderia
 * registro de tela que ele usa hoje.
 *
 * `permissaoDeEdicao` é o segundo gate, o de DESTINO (Task 6): quem só tem
 * `*.view` não pode cair no formulário de edição, porque a rota `:id/editar`
 * o barraria e ele voltaria ao dashboard sem entender por quê.
 *
 * Os cinco ícones existem em `src/assets/icones/` (medido: person, handshake,
 * group, school, menu_book) e o resolver global os serve por nome — nenhum
 * passo de build novo.
 */
export const TIPOS: Readonly<Record<TipoDeBusca, {
  readonly rotulo: string;
  readonly icone: string;
  readonly permissao: readonly string[];
  readonly permissaoDeEdicao: readonly string[];
  readonly listagem: string;
}>> = {
  cliente: {
    rotulo: 'Clientes',
    icone: 'person',
    permissao: ['*', TenantPerm.Clients_View],
    permissaoDeEdicao: ['*', TenantPerm.Clients_Update],
    listagem: '/painel/listagem/clientes',
  },
  fornecedor: {
    rotulo: 'Fornecedores',
    icone: 'handshake',
    permissao: ['*', TenantPerm.Providers_View],
    permissaoDeEdicao: ['*', TenantPerm.Providers_Update],
    listagem: '/painel/listagem/fornecedores',
  },
  funcionario: {
    rotulo: 'Funcionários',
    icone: 'group',
    permissao: ['*', TenantPerm.Employees_View],
    permissaoDeEdicao: ['*', TenantPerm.Employees_Update],
    listagem: '/painel/listagem/funcionarios',
  },
  estagiario: {
    rotulo: 'Estagiários',
    icone: 'school',
    permissao: ['*', TenantPerm.Interns_View],
    permissaoDeEdicao: ['*', TenantPerm.Interns_Update],
    listagem: '/painel/listagem/estagiarios',
  },
  menu: {
    rotulo: 'Menu',
    icone: 'menu_book',
    // O item de menu carrega a própria `permission`; esta entrada nunca é
    // consultada para decidir se o GRUPO aparece, e por isso é `['*']`
    // apenas para manter a forma do registro. Ver `busca-de-menu.spec.ts`.
    permissao: ['*'],
    permissaoDeEdicao: ['*'],
    listagem: '',
  },
};

/** Os quatro tipos que custam chamada HTTP. `menu` é dado do cliente. */
export const TIPOS_DE_ENTIDADE: readonly TipoDeBusca[] = ['cliente', 'fornecedor', 'funcionario', 'estagiario'];

/** Abaixo disto não vale disparar quatro chamadas. */
export const MINIMO_DE_CARACTERES = 2;
